var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLavaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 100,
    viewBox: "0 0 550 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m39.982 0h-39.982v74.952c0 13.839 11.163 25.033 25.032 25.033h55.218c6.2285 0 11.67-2.9399 15.472-7.3056l23.26-27.723h-79zm160.12 46.891 38.489 45.803c3.7651 4.3657 9.2435 7.3056 15.472 7.3056h41.666l-76.39-90.975c-4.6107-5.4682-11.472-9.0107-19.237-9.0107-7.7213 0-14.582 3.5426-19.149 9.0107l-76.353 90.975h41.666c6.1697 0 11.648-2.9399 15.391-7.3056zm127.26 6.2472-38.467-45.825c-3.7651-4.3951-9.2876-7.313-15.435-7.313h-41.702l76.448 90.967c4.5298 5.4829 11.472 9.0107 19.156 9.0107 7.7213 0 14.56-3.5279 19.193-9.0107l76.39-90.967h-41.658c-6.2138 0-11.692 2.9178-15.457 7.313zm127.09-6.2472 38.445 45.803c3.6989 4.3657 9.2068 7.3056 15.457 7.3056h41.644l-76.353-90.975c-4.6328-5.4682-11.508-9.0107-19.193-9.0107-7.7507 0-14.604 3.5426-19.215 9.0107l-76.412 90.975h41.702c6.1697 0 11.655-2.9399 15.413-7.3056z",
    fill: "#ed0f53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavaLogo);
export default __webpack_public_path__ + "static/media/lava_logo.68ba42578ffe1e7dc67a900d54c9a0aa.svg";
export { ForwardRef as ReactComponent };